/**
 * Modules-zone map of frontend entry points.
 *
 * Lives under `src/modules/` (not core `src/app/`). Core's moduleLoader
 * consults this map; concrete module keys are declared here beside the
 * packages they belong to.
 */
import { ComponentType } from 'react';

export interface LocalFrontendEntry {
  name: string;
  version: string;
  /** Base URL path mounted by App (e.g. "/my-module") */
  path: string;
  load: () => Promise<{ default: ComponentType }>;
}

export const localFrontends: Record<string, LocalFrontendEntry> = {};
